import React, { useState, useEffect } from 'react';
import {Row, Col, FloatingLabel ,Tooltip, OverlayTrigger, 
  Form, Dropdown, DropdownButton,
  Button , ButtonGroup, Modal } from 'react-bootstrap';
import axios from 'axios';
import { toast, ToastContainer } from "react-toastify";
import { useNavigate, useLocation, useParams } from "react-router-dom";


import categoryIcon from '../../dist/images/icons/menu/category.png'

import incomeIcon from '../../dist/images/icons/income.png'
import expensesIcon from '../../dist/images/icons/expenses.png'
import downArrowIcon from '../../dist/images/icons/down-arrow.png'
import addIcon from '../../dist/images/icons/add.png'
import editIcon from '../../dist/images/icons/edit.png'
import deleteIcon from '../../dist/images/icons/delete.png'


import category1Icon from '../../dist/images/icons/categories/1.png'
import category2Icon from '../../dist/images/icons/categories/2.png'
import category3Icon from '../../dist/images/icons/categories/3.png'
import category4Icon from '../../dist/images/icons/categories/4.png'
import category5Icon from '../../dist/images/icons/categories/5.png'
import category6Icon from '../../dist/images/icons/categories/6.png'
import category7Icon from '../../dist/images/icons/categories/7.png'
import category8Icon from '../../dist/images/icons/categories/8.png'
import category9Icon from '../../dist/images/icons/categories/9.png'


import AddCategories from './AddCategories'



const Categories = () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const location = useLocation()
  const {onFetchData} = location.state || {};

  const [categoryType, setCategoryType] = useState('1');

  const [exportType, setExportType] = useState('xlsx');
  const [categoryData, setCategoryData] = useState([]);

  const [searchQuery, setSearchQuery] = useState("");

  const [showDeleteMsgPopup, setShowDeleteMsgPopup] = useState(false);
  const [dataDeleteId, setDataDeleteId,] = useState(null);

    const {id} = useParams()
  


  const isCreatePage = location.pathname.includes('categories/create/') || location.pathname.includes('categories/edit/');



  const navigate = useNavigate();


  

  const categoryIcons = {
  1: category1Icon,
  2: category2Icon,
  3: category3Icon,
  4: category4Icon,
  5: category5Icon,
  6: category6Icon,
  7: category7Icon,
  8: category8Icon,
  9: category9Icon,
};

  const handleCategotyTypeChange = (type) => {
    setCategoryType(type)
  }


  const filteredData = categoryData?.filter((item) =>
    item?.Category?.toLowerCase()?.includes(searchQuery?.toLowerCase())
  );



  const fetchData = () => {
    axios.get(`${apiUrl}Category`)
          .then(response => {
            setCategoryData(response.data);
          })
          .catch(error => {
            console.error('Error fetching data: ', error);
          });
  }

  useEffect(() => {
        fetchData()
  }, []);

  useEffect(()=>{
    if(onFetchData){
      fetchData()
    }
  }, [onFetchData])

  useEffect(()=>{
      console.log("categoryData", categoryData)
  }, [categoryData])

  const handleCreateFromChange = (id) => {
    id ? navigate(`/categories/edit/${id}/`) : navigate(`/categories/create/`)
  }
 
  const handleDeleteChange = (deleteId) => {
    setShowDeleteMsgPopup(true);    
    setDataDeleteId(deleteId)
    console.log(deleteId);
  };

  const handleProposalDeleteCancelled = () => {
    setShowDeleteMsgPopup(false);
  }

  const handleProposalDeleteConfirmed = () => {
    setShowDeleteMsgPopup(false);
    console.log('Delete', dataDeleteId);
    axios.delete(`${process.env.REACT_APP_API_URL}Category/${dataDeleteId}/`)
      .then(response => {
        console.log('Deleted');
        setDataDeleteId(null)
        toast.success("Category Deleted");
        fetchData()
      })
      .catch(error => {
        console.log('Delete Data Error', error);
      });

  }

  return (
    <>
      <Row>
        <Col md="auto">
          <h4 className="main-title pt-2"><img src={categoryIcon} width="25" className="me-2" />Categories</h4>
        </Col>
        
        <Col>  
          <ButtonGroup aria-label="Basic example" className="categoryType"  style={{top: 0}}>
          <Button variant="secondary" 
            className={`${categoryType === '1' ? 'active' : ''}`}  
            onClick={() => handleCategotyTypeChange('1')}>
              <img src={expensesIcon} />Expense</Button>
            <Button variant="secondary" 
            className={`${categoryType === '2' ? 'active' : ''}`} 
            onClick={() => handleCategotyTypeChange('2')}>
              <img src={incomeIcon} />Income</Button>
            
          </ButtonGroup>
        </Col>
        
        {/*<Col md="auto">  
          <ButtonGroup aria-label="Basic example" className="categoryType" style={{top: 0}}>
            <Button variant="secondary" >
              <img src={downArrowIcon} />Export Data</Button>
            
            <Dropdown>
              <Dropdown.Toggle variant="success" id="dropdown-basic" className="active">
                .{exportType}
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item onClick={() => setExportType('xlsx')} >.xlsx</Dropdown.Item>
                <Dropdown.Item onClick={() => setExportType('pdf')}>.pdf</Dropdown.Item>

              </Dropdown.Menu>
            </Dropdown>
          </ButtonGroup>
        </Col>*/}
        <Col  md="auto" >          
          <input type="text" onChange={(e) => setSearchQuery(e.target.value)} className="search-input" placeholder="Search..." value={searchQuery}/>
        </Col>
      </Row >
        
      <Row className="mt-5 p-3">
        <Col md={2}>
          <div className="add-category-wrapper" onClick={() => handleCreateFromChange(null)}>
            <img src={addIcon} />
          </div>
        </Col>
        {filteredData?.filter(item => item.Category_type === categoryType).map(item => (
          <Col md={2} key={item.id}>
              <div className="category-wrapper">
                <div className="category-wrapper-inner">
                  <img src={categoryIcons[item.Category_img_id]} />
                  <h5 className="fw-bold text-center">{item.Category}</h5>
                </div>
                <div className="actionIcons">
                  <div className="icons">
                  <img src={editIcon} onClick={() => handleCreateFromChange(item.id)}/>
                  <img src={deleteIcon} onClick={() => handleDeleteChange(item.id)} />
                  </div>
                </div>
              </div>
            </Col>
        ))}
        
        
      </Row>


      {(isCreatePage || id) && <AddCategories />}


      
      <ToastContainer autoClose={1500} />
      <Modal show={showDeleteMsgPopup} onHide={handleProposalDeleteCancelled}>
      <Modal.Body closeButton><h4>Are you sure to delete this Data</h4></Modal.Body>
      <Modal.Footer>
        <button className="btn-lgt-green" onClick={handleProposalDeleteCancelled}>
          Cancel
        </button>
        <button className="btn-green ms-3" onClick={handleProposalDeleteConfirmed}>
          Delete
        </button>
      </Modal.Footer>
      </Modal>
    </>
  );
};

export default Categories;